import type { BookAndArticle, LiteratureDto } from '~/utils/solr/literature'
import { extractLabel } from '#shared/utils/solr-facet'
import { formatDate } from '~/utils/date'

export function toLiteratureDto(item: BookAndArticle, isFavorite: boolean): LiteratureDto {
  const dateOptions = item.nodeType === 'book' ? { year: 'numeric' as const } : undefined
  const baseItem = {
    id: item.id,
    title: item.title || '[Tittel ikke tilgjengelig]',
    rawTitle: item.title ?? null,
    legalAreas: (item.legal_areas || []).map(extractLabel),
    lastModified: formatDate(item.lastUpdatedByEditor || item.year, dateOptions),
    isFavorite,
    coverImage: item.coverImage || undefined,
    nodeType: item.nodeType as 'book' | 'academic_article',
    subtitle: item.subtitle || undefined,
    lastUpdatedByEditor: item.lastUpdatedByEditor || undefined,
    dateOfPublication: item.dateOfPublication,
    year: item.year || undefined,
  }

  if (item.nodeType === 'book') {
    return {
      ...baseItem,
      authors: item.author || ['[Forfatterdata ikke tilgjengelig]'],
      edition: item.editionNumber,
      previousEdition: item.previousEdition,
      lastEdition: item.lastEdition,
      type: 'Fagbok',
    }
  }

  return {
    ...baseItem,
    authors: item.authorName || ['[Forfatterdata ikke tilgjengelig]'],
    type: 'Fagartikkel',
    remoteId: item.remoteId || undefined,
  }
}
